export const createDateForBackend = (dateString) =>
	dateString + 'T00:00:00.000Z';
